/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 要請ステータス
 */
export type AcceptRequestStatusEnum =
  (typeof AcceptRequestStatusEnum)[keyof typeof AcceptRequestStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AcceptRequestStatusEnum = {
  UNDER_REQUEST: 'UNDER_REQUEST',
  DESTINATION_DETERMINED: 'DESTINATION_DETERMINED',
  DESTINATION_NONE: 'DESTINATION_NONE',
  CANCELED: 'CANCELED',
  TRANSFER: 'TRANSFER',
  RESPONSE_BY_EMS: 'RESPONSE_BY_EMS',
} as const;
